import React from 'react';

import { QUICKBOOKS_BASE_URL } from '../../../api';
import { TYPE_TITLE } from '../../../const/treatment';
import { mapDefaultRemoteOptions, mapPayeeOptions } from '../../../Helper';
import { RemoteOptionsResponse } from '../../../types';
import { FormTypeOption, FormTypeOptionComponentProps } from '../../../types/treatment';
import Form from '../Form/Form';

const SAVE_TREATMENT_ENDPOINT = `${QUICKBOOKS_BASE_URL}/:documentId/createExpense`;

const mapRemoteOptions = (responseData: RemoteOptionsResponse) => {
  const payees = mapPayeeOptions(responseData.vendors, responseData.employees);
  const defaultRemoteOptions = mapDefaultRemoteOptions(responseData);

  return {
    ...defaultRemoteOptions,
    payees,
  };
};

export const DISABLED_FIELDS = {
  isMethodDisabled: false,
  isAccountDisabled: false,
  isTermsDisabled: true,
  isDueOnDisabled: true,
};

const REQUIRED_FIELDS = {
  isMethodRequired: false,
  isAccountRequired: true,
  isTermsRequired: false,
  isDueOnRequired: false,
};

const PaidBillForm = ({ register, control, dropdowns }: FormTypeOptionComponentProps) => {
  return (
    <Form
      register={register}
      control={control}
      dropdowns={dropdowns}
      disabledFields={DISABLED_FIELDS}
      requiredFields={REQUIRED_FIELDS}
    />
  );
};

export default PaidBillForm;
export const title = TYPE_TITLE['Expense'];
const optionName = TYPE_TITLE['Expense'];
const id = 'Expense';

export const PaidBillFormOption: FormTypeOption = {
  id,
  title,
  optionName,
  Component: PaidBillForm,
  mapRemoteOptions,
  disabledFields: DISABLED_FIELDS,
  requiredFields: REQUIRED_FIELDS,
  saveTreatmentEndpoint: SAVE_TREATMENT_ENDPOINT,
};
